import { render, staticRenderFns } from "./ViewReport18.vue?vue&type=template&id=fc56b69c&scoped=true"
import script from "./ViewReport18.vue?vue&type=script&lang=js"
export * from "./ViewReport18.vue?vue&type=script&lang=js"
import style0 from "./ViewReport18.vue?vue&type=style&index=0&id=fc56b69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc56b69c",
  null
  
)

export default component.exports